<template>
  <div>
    <h5
      :class="placeholder"
    >
      Notitie plaatsen
    </h5>
    <div class="form-group">
      <material-textarea
        v-model="comment"
        label="Opmerking"
        :placeholder="placeholder"
        class="form-control"
        :class="placeholder"
        rows="3"
      />
      <material-button
        v-if="comment.length > 2"
        type="button"
        class="btn btn-primary mt-2"
        @click.prevent="submit"
      >
        Opslaan
      </material-button>
    </div>
  </div>
</template>

<script>
import MaterialButton from '@/components/MaterialButton.vue';
import MaterialTextarea from '@/components/MaterialTextarea.vue';
import ReportDetailStore from '@/store/pages/Report/report-detail-store';

import { addLog } from '@/api/providers/reports';

export default {
  components: {
    MaterialButton,
    MaterialTextarea
  },

  data() {
    return {
      comment: '',
    }
  },

  computed: {
    isLoading() {
      return ReportDetailStore.getters.isLoading;
    },

    placeholder() {
      return this.isLoading
        ? 'placeholder'
        : '';
    }
  },

  methods: {
    async submit() {
        let log = await addLog(
          ReportDetailStore.getters.report.id, 
          this.comment,
        );

        ReportDetailStore.dispatch('addLogItem', log);
        this.comment = '';
    }
  }
}
</script>